// L6 tramo 5c (10.264 — existencia de documento, no de fecha). Cantidad de meses que cubre cada
// factura de GESTIÓN de un negocio de cartelería, derivado de `meses_facturacion` (default 1 —
// mensual — si no hay datos). Usado por `CarteleriaList` para la etiqueta de periodicidad.
//
// Si el mes es de 2026 (alcance real de la migración) Y su folio resuelve a un documento real en el
// sistema (`facturas_sii_emitidas`), agrupar por la factura del PUENTE (`factura_sii_emitida_id` vía
// `linea_id`), no por el folio de texto — así una factura editada/reasignada sigue agrupando bien.
// Fuera de ese alcance (Perú, sin SII — 10.265 —, o cualquier año distinto de 2026) el folio sigue
// siendo la única fuente posible y agrupa exactamente como antes, SIN EXCEPCIÓN — ni siquiera si por
// coincidencia el folio matchea un documento real de otro origen (caso real medido: folios de líneas
// 2025 coinciden por azar con facturas de diciembre-2025 cargadas el mismo día por otro frente).
//
// @param {Object} n - negocio de cartelería (trae `id` y `meses_facturacion`).
// @param {Object} maps
// @param {Map<string,(number|string)>} maps.lineaIdPorClaveGestion - `${negocio_id}-${ano}-${mes}` → linea_id.
// @param {Map<(number|string),(number|string)>} maps.facturaIdPorLineaGestion - linea_id → factura_sii_emitida_id.
// @param {Set<string>} maps.foliosGestionConDocumento - folios (texto) con un documento real en el sistema.
// @returns {number}
export const getMesesPorFactura = (
  n,
  { lineaIdPorClaveGestion, facturaIdPorLineaGestion, foliosGestionConDocumento }
) => {
  const entries = Array.isArray(n?.meses_facturacion) ? n.meses_facturacion : [];
  if (entries.length === 0) return 1;
  const byFactura = {};
  entries
    .filter((e) => e && e.tipo === "gestion" && e.facturanumero)
    .forEach((e) => {
      const folio = String(e.facturanumero);
      let clave = `folio:${folio}`;
      if (String(e.ano) === "2026" && foliosGestionConDocumento?.has(folio)) {
        const lineaId = lineaIdPorClaveGestion?.get(`${n.id}-${e.ano}-${String(e.mes).padStart(2, "0")}`);
        const facturaId = lineaId != null ? facturaIdPorLineaGestion?.get(lineaId) : null;
        clave = facturaId != null ? `factura:${facturaId}` : `sin-puente:${n.id}:${e.ano}:${e.mes}`;
      }
      byFactura[clave] = (byFactura[clave] || 0) + 1;
    });
  const counts = Object.values(byFactura);
  if (counts.length === 0) return 1;
  return Math.max(...counts);
};
